import steps from '../../survey/stepsV2';
/* eslint-disable no-lonely-if */
let hasTrackedDisplayError = false;

const isFBInApp = () => /FBAN|FBAV|Instagram/i.test(navigator.userAgent || '');
function isIOS() {
  return /iP(hone|ad|od)/i.test(navigator.userAgent || '')
    || (navigator.platform && /iPhone|iPad|iPod/i.test(navigator.platform));
}

function readSafeAreaBottom() {
  const probe = document.createElement('div');
  probe.style.cssText = `
    position:absolute;visibility:hidden;pointer-events:none;
    padding-bottom: env(safe-area-inset-bottom);
  `;
  document.documentElement.appendChild(probe);
  const pb = parseFloat(getComputedStyle(probe).paddingBottom) || 0;
  probe.remove();
  return Math.max(0, Math.round(pb));
}

export default function useViewportUnits(
  target,
  opts,
) {
  if (!target) return;
  const el = target;

  const {
    extraBottomPx = Number(
      new URL(window.location.href).searchParams.get('vh_extra') || 0,
    ),
    maxCutPx = 200,
    fbIosMinPx = 24,
    barsFloorThresholdPx = 33,
  } = opts;

  const clamp = (n, lo, hi) => Math.min(Math.max(n, lo), hi);

  const update = () => {
    const vv = window.visualViewport;
    const ih = window.innerHeight;
    const ch = document.documentElement.clientHeight;
    const sh = window.screen?.height ?? ih;
    const savh = window.screen?.availHeight ?? ih;
    const outer = window.outerHeight || ih;
    const vvH = vv?.height ?? ih;
    const rawHeight = Math.round(vvH);
    const vhUnit = rawHeight / 100;

    // сколько пикселей "съели" бары браузера
    const barsTotal = Math.max(0, Math.round(sh - vvH));

    const candidates = [
      Math.max(0, ih - ch),
      Math.max(0, savh - ih),
      Math.max(0, sh - ih),
      Math.max(0, vv?.offsetTop ?? 0),
      Math.max(0, outer > ih ? outer - ih : 0),
    ];

    const safeEnv = readSafeAreaBottom();
    let approx = Math.max(...candidates, 0);
    if (barsTotal > barsFloorThresholdPx) {
      approx = 0;
    }

    const needsMinFloor = isIOS() && isFBInApp() && barsTotal <= barsFloorThresholdPx;

    if (needsMinFloor) {
      approx = Math.max(approx, fbIosMinPx);
    }

    const shouldApplyExtra = needsMinFloor && extraBottomPx > 0;

    const baseCut = approx + safeEnv;
    const cut = clamp(
      baseCut + (shouldApplyExtra ? extraBottomPx : 0),
      0,
      maxCutPx,
    );

    const effective = clamp(rawHeight - cut, 0, 10000);
    const rounded = Math.round(effective);
    const bags = localStorage.getItem('bags') === 'true';

    if (needsMinFloor) {
      el.style.height = `${rounded}px`;

      el.style.setProperty('--vh', `${vhUnit}px`);
      el.style.setProperty('--bars-total', `${barsTotal}px`);
      el.style.setProperty('--approx-safe-bottom', `${approx}px`);
      el.style.setProperty('--safe-env-bottom', `${safeEnv}px`);
      el.style.setProperty(
        '--extra-bottom',
        `${shouldApplyExtra ? extraBottomPx : 0}px`,
      );
      el.style.setProperty('--fb-inapp', isFBInApp() ? '1' : '0');
      el.style.setProperty('--effective-height', `${rounded}px`);
      el.dataset.effectiveHeight = String(rounded);
      localStorage.setItem('bags', 'true');
      if (!hasTrackedDisplayError) {
        hasTrackedDisplayError = true;
        steps.analytics.send({
          event: {
            event: 'display_error',
          },
        });
        window.dataLayer.push({
          event: 'display_error',
        });
      }
    } else {
      if (bags) {
        el.style.removeProperty('height');
        el.style.removeProperty('--vh');
        el.style.removeProperty('--bars-total');
        el.style.removeProperty('--approx-safe-bottom');
        el.style.removeProperty('--safe-env-bottom');
        el.style.removeProperty('--extra-bottom');
        el.style.removeProperty('--fb-inapp');
        el.style.removeProperty('--effective-height');
        delete el.dataset.effectiveHeight;
        localStorage.removeItem('bags');
      }
    }
  };

  // const rafUpdate = () => requestAnimationFrame(update);

  update();
  // window.addEventListener('resize', rafUpdate, { passive: true });
  // window.visualViewport?.addEventListener('resize', update);
  window.visualViewport?.addEventListener('scroll', update);

  return () => {
    // window.removeEventListener('resize', rafUpdate);
    // window.visualViewport?.removeEventListener('resize', update);
    window.visualViewport?.removeEventListener('scroll', update);
  };
}
